$(document).ready(() => {
  // ====HELPERS AND GLOBAL VAR=======
  const arrowIcon = `<svg fill="none" viewBox="0 0 15 24"><path fill="currentColor" d="M12.17 0L15 2.829l-9.339 9.175L15 21.171 12.17 24 0 12.004 12.17 0z"/></svg>`;

  // =++++++++++FUNCTIONS BODIES++++++++++=

  ///  ========= LOGO LIST SLIDER INIT =========
  const logoListWithSlider = () => {
    if ($(".logoListWithSlider").length > 0) {
      $(".logoListWithSlider").each(function () {
        new Flickity(this, {
          lazyLoad: 2,
          freeScroll: false,
          imagesLoaded: true,
          draggable: true,
          cellAlign: "left",
          wrapAround: true,
          pageDots: false,
          contain: true,
          prevNextButtons: true,
          initialIndex: 0,
          fade: false,
          watchCSS: false,
        });
      });
      $(".logoListWithSlider")
        .find(".flickity-button")
        .empty()
        .html(`${arrowIcon}`);
    }
  };

  ///  ========= GALLERY SLIDER INIT =========
  const galleryRowSlider = () => {
    if ($(".sliderGallery").length > 0) {
      $(".sliderGallery").each(function () {
        let cssWatchForMobile = false;
        let mobileOnly = $(this).attr("data-mobileOnly");
        if (mobileOnly == "true" || mobileOnly == true) {
          cssWatchForMobile = true;
        }
        new Flickity(this, {
          lazyLoad: 2,
          freeScroll: false,
          imagesLoaded: true,
          draggable: true,
          cellAlign: "left",
          wrapAround: true,
          pageDots: false,
          contain: true,
          prevNextButtons: false,
          initialIndex: 0,
          fade: false,
          watchCSS: cssWatchForMobile,
        });
      });
    }
  };

  // =======CUSTOM PRICE RANGE WIDEGT=========
  const customPriceRangeWidget = () => {
    if ($(".price-slider").length > 0) {
      const $sliders = $(".price-slider");
      if (!$sliders.length) return;

      function formatMoney(value, currency) {
        const num = Number(value || 0);
        return currency + num.toLocaleString();
      }
      function clamp(val, min, max) {
        return Math.min(Math.max(val, min), max);
      }

      function initPriceSlider($slider) {
        const currency = $slider.data("currency") || "$";
        const min = Number($slider.data("min")) || 0;
        const max = Number($slider.data("max")) || 1000;

        const $block = $slider.closest(
          ".faceted-filter-group-display__price-range"
        );
        const $hiddenMin = $block.find(".js-price-min");
        const $hiddenMax = $block.find(".js-price-max");

        // ✅ Prefer currently applied values (from hidden inputs if present)
        let appliedMin = parseFloat(
          ($hiddenMin.val() || "").toString().replace(/,/g, "")
        );
        let appliedMax = parseFloat(
          ($hiddenMax.val() || "").toString().replace(/,/g, "")
        );

        // Fallback to data-start-* if hidden inputs are empty
        if (Number.isNaN(appliedMin))
          appliedMin = Number($slider.data("start-min"));
        if (Number.isNaN(appliedMax))
          appliedMax = Number($slider.data("start-max"));

        if (Number.isNaN(appliedMin)) appliedMin = min;
        if (Number.isNaN(appliedMax)) appliedMax = max;

        const $rangeMin = $slider.find(".range-min");
        const $rangeMax = $slider.find(".range-max");
        const $fill = $slider.find(".price-slider__range-fill");
        const $labelMin = $slider.find(".price-slider__value--min");
        const $labelMax = $slider.find(".price-slider__value--max");

        // Set starting values
        $rangeMin.attr({ min, max }).val(clamp(appliedMin, min, max));
        $rangeMax.attr({ min, max }).val(clamp(appliedMax, min, max));
        $hiddenMin.val(clamp(appliedMin, min, max));
        $hiddenMax.val(clamp(appliedMax, min, max));

        function updateUI() {
          let vMin = Number($rangeMin.val());
          let vMax = Number($rangeMax.val());

          if (vMin > vMax) {
            const t = vMin;
            vMin = vMax;
            vMax = t;
            $rangeMin.val(vMin);
            $rangeMax.val(vMax);
          }

          // Labels
          $labelMin.text(formatMoney(vMin, currency));
          $labelMax.text(formatMoney(vMax, currency));

          // Fill
          const left = ((vMin - min) / (max - min)) * 100;
          const right = ((vMax - min) / (max - min)) * 100;
          $fill.css({ left: left + "%", right: 100 - right + "%" });

          // Sync hidden inputs only (no submit)
          $hiddenMin.val(vMin);
          $hiddenMax.val(vMax);
        }

        // ✅ Prevent autosubmit bubbling from theme scripts
        const stop = (e) => {
          e.preventDefault();
          e.stopPropagation();
          updateUI();
        };
        $rangeMin.on("change", stop);
        $rangeMax.on("change", stop);

        // Smooth updates while sliding
        $rangeMin.on("input", updateUI);
        $rangeMax.on("input", updateUI);

        // Prevent Enter key from submitting while focused on sliders
        $slider.on("keydown", function (e) {
          if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
          }
        });

        updateUI();
      }

      // Initialize existing sliders
      $sliders.each(function () {
        initPriceSlider($(this));
      });

      // If your theme re-renders filters via Ajax/sections, re-init on these events:
      $(document).on(
        "shopify:section:load shopify:section:select section:loaded facetedFilters:rendered",
        function () {
          $(".price-slider").each(function () {
            initPriceSlider($(this));
          });
        }
      );

      // Belt & suspenders: capture change bubbling at the form level only from our slider
      $(document).on(
        "change",
        ".faceted-filter-form .price-slider input[type=range]",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
        }
      );
    }
  };

  // =====COMMON CLICK EVENTS AND DROPDOWNS=====
  const toggleDropDownAndSortingFilter = () => {
    $(document).on("click", "button.dropDownOpener", function () {
      $(".customDropDown")
        .not($(this).parent(".customDropDown"))
        .removeClass("activeDropDown");
      $(".dropDownContent").not($(this).next(".dropDownContent")).slideUp(200);
      $(this).parent(".customDropDown").toggleClass("activeDropDown");
      $(this).next(".dropDownContent").slideToggle(400);
    });

    $(document).on("click", "button.sortSelector", function () {
      var $thisText = $(this).text();
      var filterValue = $(this).attr("data-filter");
      $(this)
        .parent(".dropDownContent")
        .prev(".dropDownOpener")
        .children("span")
        .text($thisText);
      if ($(".faceted-filter-form").length > 0) {
        $(".faceted-filter-form").slideUp(200);
      }
      $(".dropDownContent").slideUp(200);
      if ($("#sort-by").length > 0) {
        $("#sort-by").val(filterValue).change();
      }
    });
  };

  const customClickEvents = () => {
    $(document).on("click", "button.filterOpener", function () {
      $("body, html").addClass("hideScroll filtersOpen");
      $(".collectionFilterDrawer").addClass("showDrawer");
    });
    $(document).on("click", ".closeFilters", function () {
      $("body, html").removeClass("hideScroll filtersOpen");
      $(".collectionFilterDrawer").removeClass("showDrawer");
    });
  };

  // =====MEGA MENU SETTINGS=======
  const megaMenuSettings = () => {
    // Helper: hide all images + remove hovered class in this mega menu
    const hideMegaMenuImages = ($megaMenu) => {
      const $contentWrapper = $megaMenu.find(".megaMenuContentImages");
      $contentWrapper.find(".dynamicImg1, .dynamicImg2").hide();
      $megaMenu.find(".sideSubMenu__links a").removeClass("hovered");
    };

    // Helper: update images/titles for a given mega menu, using a specific link
    const setMegaMenuImagesFromLink = ($megaMenu, $link) => {
      if (!$link || !$link.length) {
        hideMegaMenuImages($megaMenu);
        return;
      }

      const $contentWrapper = $megaMenu.find(".megaMenuContentImages");

      const img1 = $link.data("menuimg1");
      const title1 = $link.data("menuimgtitle1");
      const url1 = $link.data("menuimgurl1");

      const img2 = $link.data("menuimg2");
      const title2 = $link.data("menuimgtitle2");
      const url2 = $link.data("menuimgurl2");

      const $dynamic1 = $contentWrapper.find(".dynamicImg1");
      const $dynamic2 = $contentWrapper.find(".dynamicImg2");

      const hasImg1 = !!img1;
      const hasImg2 = !!img2;
      const hasAny = hasImg1 || hasImg2;

      // If no images at all: hide and bail
      if (!hasAny) {
        hideMegaMenuImages($megaMenu);
        return;
      }

      // We have at least one image → show wrapper and manage hovered class
      $contentWrapper.show();

      // First image block
      if (hasImg1) {
        $dynamic1.show().find("img").attr("src", img1);
        $dynamic1.find("a").attr("href", url1 || "#");
        $dynamic1.find(".megaMenuImgTitle1").text(title1 || "");
      } else {
        $dynamic1.hide();
      }

      // Second image block
      if (hasImg2) {
        $dynamic2.show().find("img").attr("src", img2);
        $dynamic2.find("a").attr("href", url2 || "#");
        $dynamic2.find(".megaMenuImgTitle2").text(title2 || "");
      } else {
        $dynamic2.hide();
      }

      // hovered class: only on the link that controls the visible images
      $megaMenu.find(".sideSubMenu__links a").removeClass("hovered");
      $link.addClass("hovered");
    };

    // Helper: set default images for a given mega menu (first link with data)
    const setDefaultImagesForMegaMenu = ($megaMenu) => {
      // Find currently-opened top item
      const $openedTopItem = $megaMenu.find(".megaMenuLinkItem.opened").first();

      let $subMenu = null;
      if ($openedTopItem.length) {
        const id = $openedTopItem.data("nextmenu"); // e.g. "#blockid-1"
        $subMenu = $megaMenu.find(id);
      } else {
        // Fallback: any visible submenu
        $subMenu = $megaMenu.find(".sideSubMenu:visible").first();
      }
      if (!$subMenu || !$subMenu.length) {
        hideMegaMenuImages($megaMenu);
        return;
      }

      // Find first child link with image data
      const $firstLinkWithData = $subMenu
        .find(
          ".sideSubMenu__links a[data-menuimg1], .sideSubMenu__links a[data-menuimg2]"
        )
        .first();

      if ($firstLinkWithData.length) {
        setMegaMenuImagesFromLink($megaMenu, $firstLinkWithData);
      } else {
        // No images in this submenu at all → hide
        hideMegaMenuImages($megaMenu);
      }
    };

    // MAIN LEVEL: hover on top items
    $(document).on(
      "mouseenter",
      ".mega-menu__linklist .megamenuLinkList .megaMenuLinkItem",
      function () {
        var nextMenuID = $(this).data("nextmenu");

        // Remove opened from all, add to hovered
        $(".megaMenuLinkItem").removeClass("opened");
        $(this).addClass("opened");

        // Scope to this mega menu only
        const $megaMenu = $(this).closest(".mega-menu__linklist");

        // Hide all submenus in this mega menu
        $megaMenu.find(".sideSubMenu").hide();

        // Show the matched submenu
        const $subMenu = $megaMenu.find(nextMenuID).fadeIn(300);

        // Set default images for this submenu: first link with data
        const $firstLinkWithData = $subMenu
          .find(
            ".sideSubMenu__links a[data-menuimg1], .sideSubMenu__links a[data-menuimg2]"
          )
          .first();

        if ($firstLinkWithData.length) {
          setMegaMenuImagesFromLink($megaMenu, $firstLinkWithData);
        } else {
          // No image data in this submenu
          hideMegaMenuImages($megaMenu);
        }
      }
    );

    // SUBMENU: hover on collection links to change images/titles
    $(document).on(
      "mouseenter",
      ".mega-menu__linklist .sideSubMenu__links a",
      function () {
        const $link = $(this);

        // Scope everything to THIS mega menu instance
        const $megaMenu = $link.closest(".mega-menu__linklist");

        setMegaMenuImagesFromLink($megaMenu, $link);
      }
    );

    // Optional: when leaving the entire mega menu, reset to opened item's first image
    $(document).on("mouseleave", ".mega-menu__linklist", function () {
      const $megaMenu = $(this);
      const firstOpened = $megaMenu
        .find(".megaMenuLinkItem.opened")
        .data("nextmenu");

      $megaMenu.find(".sideSubMenu").hide();
      if (firstOpened) {
        const $subMenu = $megaMenu.find(firstOpened).fadeIn(300);

        const $firstLinkWithData = $subMenu
          .find(
            ".sideSubMenu__links a[data-menuimg1], .sideSubMenu__links a[data-menuimg2]"
          )
          .first();

        if ($firstLinkWithData.length) {
          setMegaMenuImagesFromLink($megaMenu, $firstLinkWithData);
        } else {
          hideMegaMenuImages($megaMenu);
        }
      } else {
        hideMegaMenuImages($megaMenu);
      }
    });

    // for mobile toggle
    $(document).on("click", ".hasNextMenu", function () {
      $(".subMenuAndImagesArea").removeClass("showThirdLevelMenu");
      $(this)
        .parent(".megamenuLinkList")
        .next(".subMenuAndImagesArea")
        .addClass("showThirdLevelMenu");
    });
    $(document).on("click", ".backToSecondLevel", function () {
      $(".subMenuAndImagesArea").removeClass("showThirdLevelMenu");
    });

    // ✅ Initial default images for each mega menu on page load
    $(".mega-menu__linklist").each(function () {
      const $megaMenu = $(this);
      setDefaultImagesForMegaMenu($megaMenu);
    });

    if($(".header__menu-items").length > 0){
      var $scope = $('.centerMenuAndLogoArea');

      function resetMenus() {
        $scope.find('.header__item').removeClass('is-dimmed is-active-hover');
      }

      // fires reliably while moving between items (and inside their children)
      $scope.on('mouseover', '.header__item', function () {
        var $item = $(this);

        // HARD reset every time before applying new state
        resetMenus();

        // dim everything, then activate current
        $scope.find('.header__item').addClass('is-dimmed');
        $item.removeClass('is-dimmed').addClass('is-active-hover');
      });

      // reset only when leaving the whole header area
      $scope.on('mouseleave', function () {
        resetMenus();
      });
    }
  };

  // =====MOBILEHEADER AND MENU=======
  const mobileHeader = () => {
    const headerHeight = $(".headerContainer.sticky-true").height();
    $(".headerContainer.sticky-true").css("height", headerHeight);

    $(window).scroll(function () {
      if ($(this).scrollTop() > 42) {
        $(".headerContainer.sticky-true").addClass("scrolled");
      } else {
        $(".headerContainer.sticky-true").removeClass("scrolled");
      }
    });

    $(document).on("click", ".menuBtn", function () {
      $("html, body").toggleClass("hideScroll");
      $(".mobile-header").toggleClass("showMenu");
      if ($(".mobile-header").hasClass("showMenu")) {
        $(".header-section").attr("data-lenis-prevent", "true");
      } else {
        $(".header-section").removeAttr("data-lenis-prevent");
      }
    });

    $(document).on("click", ".backToFirstLevel", function () {
      $(".submenu__input:checked").prop("checked", false);
    });
  };

  // =====STICKY ATC BAT======

  const stickyATCBarSettings = () => {
    if ($(".stickyATCBar").length > 0) {
      $(document).on("click", ".swatch-element label", function () {
        setTimeout(function () {
          var updatedPriceUI = $(
            ".js-product_section .price-ui .price .money"
          ).html();
          $(".stickyBarProdPriceArea").empty().html(updatedPriceUI);
        }, 600);
      });

      $(document).on("click", ".stikcyAtcBtn", function () {
        const $this = $(this);
        const $variantId = $(".js-product_section .variant-selection").attr(
          "variant"
        );
        const $thisBtnHtml = $this.html();
        $this
          .empty()
          .html(`<span class="button is-loading is-loading--icon-only"></span>`)
          .addClass("focused");

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: { quantity: 1, id: $variantId },
          dataType: "json",
          success: function () {
            Shopify.theme.jsAjaxCart.updateView();
            $this.empty().html(`Added`).removeClass("focused");
            setTimeout(() => {
              $this.empty().html($thisBtnHtml);
              Shopify.theme.jsAjaxCart.showDrawer();
            }, 1600);
          },
        });
      });

      $(window).on("scroll", function () {
        let section = $(".productSectionArea");
        let stickyBar = $(".stickyATCBar");

        if (section.length === 0) return;
        let sectionBottom = section.offset().top + section.outerHeight();
        let windowBottom = $(window).scrollTop() + $(window).height();
        if (windowBottom >= sectionBottom) {
          stickyBar.addClass("reveal");
        } else {
          stickyBar.removeClass("reveal");
        }
      });
    }
  };

  
  // =====STICKY ATC BAT======
  const megaMenuDropDowns = ()=>{
    $(document).on("click", ".dropDownOpenerTag", function () {
      $(this).toggleClass("isOpen");
      $(this).next(".menuDropDownItems.thirdLevelItems").slideToggle(300);
    });
    if($(".mobile-menu__first-level .close-sub-dropdown").length > 0){
      $(".mobile-menu__first-level .close-sub-dropdown").html(arrowIcon)
    }
  };

  

  // =====FUNCTIONS CALLING ON LOAD======
  logoListWithSlider();
  galleryRowSlider();
  customPriceRangeWidget();
  toggleDropDownAndSortingFilter();
  customClickEvents();
  megaMenuSettings();
  mobileHeader();
  stickyATCBarSettings();
  megaMenuDropDowns();
});
